import axios from 'axios';
import { getLocalItem, getSessionItem, removeLocalItem, removeSessionItem, setLocalItem, setSessionItem } from '../utils/safeStorage';

const resolveApiBase = () => {
  const envBase =
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    '';
  if (typeof window === 'undefined') return envBase || '';
  const fallback = window.location.origin || '';
  if (!envBase) return fallback;
  return envBase;
};

const API_BASE = resolveApiBase().replace(/\/$/, '');
const CUSTOMER_REFRESH_PATHS = ['/api/auth/customer/refresh', '/api/customer/refresh'];

const guestClient = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

const ACCESS_KEY = 'customerAccessToken';

const storeToken = (token) => {
  if (!token) return;
  setSessionItem(ACCESS_KEY, token);
  setLocalItem(ACCESS_KEY, token);
};

const clearToken = () => {
  removeSessionItem(ACCESS_KEY);
  removeLocalItem(ACCESS_KEY);
};

const refreshGuestToken = async () => {
  try {
    for (const path of CUSTOMER_REFRESH_PATHS) {
      const res = await fetch(`${API_BASE}${path}`, {
        method: 'POST',
        credentials: 'include',
      });
      if (res.status === 404 || res.status === 405) continue;
      if (!res.ok) return null;
      const data = await res.json().catch(() => ({}));
      const token = data?.accessToken || data?.token;
      if (token) storeToken(token);
      return token || null;
    }
    return null;
  } catch {
    return null;
  }
};

guestClient.interceptors.request.use((config) => {
  const token = getSessionItem(ACCESS_KEY) || getLocalItem(ACCESS_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

guestClient.interceptors.response.use(
  (res) => res,
  async (err) => {
    if (err.response?.status === 401 && !err.config?.__isRetryRequest) {
      const refreshed = await refreshGuestToken();
      if (refreshed) {
        const retryConfig = { ...err.config, __isRetryRequest: true };
        retryConfig.headers = { ...(retryConfig.headers || {}), Authorization: `Bearer ${refreshed}` };
        return guestClient.request(retryConfig);
      }
      clearToken();
    }
    const message = err.response?.data?.message || err.message || 'Request failed';
    return Promise.reject(new Error(message));
  }
);

export default guestClient;


